export default __webpack_public_path__ + "static/media/ispo.dd4ef467.png";